import React from 'react';
import './AuthPage.scss';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import { isTdk } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { injectIntl } from 'react-intl';
import SignUp from 'Flow2/components/AdvancedBox/AdvancedForm/SignUp/SignUp';
import SignIn from 'Flow2/components/AdvancedBox/AdvancedForm/SignIn/SignIn';
import Languages from 'Flow2/components/Languages/Languages';
import Logo from 'Flow2/components/Logo/Logo';
import * as cTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/ConfigTypes';

class AuthPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false
        };
    }

    fm = (id) => this.props.intl.formatMessage({ id });

    onFormBtn = () => {
        this.setState({ showForm: true });
        console.log("LOGS: AuthPage CLICK");
    }

    componentDidMount() { }

    showFormBtn = () => {
        return (
            <div className="authpage-btn" onClick={this.onFormBtn}>
                {this.fm('page.auth.link.register')}
            </div>)
    }

    showTop = () => {
        return (
            <div className="authpage-top">
                <div className="authpage-logo">
                    <img src={this.props.logo} />
                </div>
                <h1 className="authpage-apptitle">{this.fm('app.title')}</h1>
            </div>
        )
    }

    showFooter = () => {
        return (
            <div className="authpage-footer">
                <div>{`© `}{this.fm('data.footer.copyright')}</div>
                <div>{this.fm('data.footer.logotxt')}</div>
            </div>
        )
    }

    showSignIn = () => {
        return (
            <div className="authpage">
                <Languages />
                {this.showTop()}
                <SignIn isOpened={this.state.showForm} heading={this.fm('app.loginTitle')}
                    subtxtItems={cTypes.SIGNIN_TDK_SUBTXT_ITEMS}
                    isSignInForm={this.props.isSignInForm} logo={this.props.logo}
                    infoItems={cTypes.SIGNIN_TDK_INFO_ITEMS}
                    checkValidity={this.props.checkValidity}
                    bottomItems={cTypes.SIGNIN_TDK_BOTTOM_ITEMS}
                    lg={this.props.lg}
                    onClose={() => this.setState({ showForm: false })} />
                {this.showFooter()}
            </div>
        )
    }

    render() {
        if (isTdk()) {
            if (this.props.isSignInForm) return this.showSignIn();
            return (
                <div className="Auth">
                    {this.showFormBtn()}
                    {this.state.showForm && (
                        <SignUp isOpened={this.state.showForm} heading={this.fm('auth.welcome')}
                            logo={this.props.logo} withLoginBtn={true} data={cTypes.SIGNUP_TDK_ITEMS}
                            subtxtItems={cTypes.SIGNUP_TDK_SUBTXT_ITEMS} lg={this.props.lg}
                            onClose={() => this.setState({ showForm: false })} />)}
                </div>)
        }
        return null;
    }
}

const mapStateToprops = (state) => ({
    flexObjects: state.share.flexObjects,
    lg: state.ui.language
})

const mapDispatchToProps = (dispatch) => ({
    updateflexObjects: (obj) => dispatch(actions.updateFlexObjects(obj)),
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(AuthPage));